import ContactToManageNotice from './ContactToManageNotice';
import BillingPausedNotice from './BillingPausedNotice';
import { SubscriptionLockReason } from '../utils/useSubscriptionManagementLock';

export default function SubscriptionLockedNotice({
  reason,
  action,
}: {
  reason: SubscriptionLockReason;
  action?: string;
}) {
  if (reason === 'payment-migration') {
    return <BillingPausedNotice />;
  }
  if (reason === 'paypal') {
    return <ContactToManageNotice action={action} />;
  }
  return null;
}
